import { render, staticRenderFns } from "./CodeChef.vue?vue&type=template&id=1f543c72&scoped=true&"
import script from "./CodeChef.vue?vue&type=script&lang=js&"
export * from "./CodeChef.vue?vue&type=script&lang=js&"
import style0 from "./CodeChef.vue?vue&type=style&index=0&id=1f543c72&prod&lang=css&"
import style1 from "./CodeChef.vue?vue&type=style&index=1&id=1f543c72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f543c72",
  null
  
)

export default component.exports